import { combineReducers } from 'redux';

import hub from './hub/reducer';
import manageApplication from './manageapplication/reducer';
import studentLookup from './studentlookup/reducer';
import applicationHistory from './applicationhistory/reducer';

export default combineReducers({
  hub,
  manageApplication,
  studentLookup,
  applicationHistory,
});



// WEBPACK FOOTER //
// ./src/pages/manageapplication/state/reducer.js